import React, { useEffect, useRef, useState } from 'react'
import Topbar from './Topbar'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronRight } from '@fortawesome/free-solid-svg-icons'
import OverView from '../Overview'
import { useNavigate, useParams } from 'react-router-dom'
import { selectCompletedLessonCount, selectCourseModule, selectCourseModuleContent, selectLessonBySlugs, selectModuleBySlug } from '../../redux/courseModuleSlice'
import { useSelector } from 'react-redux'
import { selectCourseList } from '../../redux/courseListSlice'
import LearnTubeXIllustartion from '../../components/LearnTubeXIllustartion'
import { toast } from 'react-toastify'
import { selectAuthentication } from '../../redux/authenticationSlice'
import { selectBottomIllustationStatus } from '../../redux/bottomIllustration'
import { selectSubscriptionStatus } from '../../redux/subscriptionStatusSlice'

const LockedLessons = () => {

    const { module_slug, lesson_slug } = useParams()
    
    const [showOverview, setShowOverview] = useState(false)
    const [isAtEnd, setIsAtEnd] = useState(false)

    const courseModuleContent = useSelector(selectCourseModuleContent)
    const subject_name = useSelector(selectCourseList)?.courseName
    const moduleDetails = useSelector((state) => selectModuleBySlug(state, module_slug))
    const lessonDetails = useSelector((state) => selectLessonBySlugs(state, module_slug, lesson_slug))
    const completedLessonCount = useSelector((state) => selectCompletedLessonCount(state, module_slug))
    const lessonIndex = moduleDetails?.module_content?.findIndex((item) => item?.lesson_slug === lesson_slug) + 1
    const courseModule = useSelector(selectCourseModule)
    const authentication = useSelector(selectAuthentication)
    const bottomIllustrationStatus = useSelector(selectBottomIllustationStatus)
    const subscriptionStatus = useSelector(selectSubscriptionStatus)

    const sentinelRef = useRef(null)
    const navigate = useNavigate()


    useEffect(() => {
        const index  = courseModuleContent?.findIndex((item) => item?.module_slug === module_slug) - 1;
        console.log(courseModuleContent?.[index]?.module_progress);
        if (index >= 0 && courseModuleContent?.[index]?.module_progress === 100){
            toast.warning('Loading your Module. Please wait!')
        } else {
            toast.warning('Complete previous module to unlock this module.')
        }
    }, [courseModuleContent, module_slug])

    useEffect(() => {
        const sentinel = sentinelRef.current;
        const observer = new IntersectionObserver((entries) => {
            // If the sentinel comes into view, setIsAtEnd to true
            if (entries[0].isIntersecting) {
                setIsAtEnd(true);
            } else {
                setIsAtEnd(false);
            }
        });

        if (sentinelRef.current) {
            observer.observe(sentinelRef.current);
        }

        return () => {
            if (sentinel) {
                observer.unobserve(sentinel);
            }
        }
    }, [sentinelRef]);

    const handleCourseCrumb = () => {
        navigate(`/${encodeURIComponent(subject_name)}`)
    }
    
    return (
        <>
            {!showOverview ? <div className='text-white flex-1 mx-auto max-w-3xl'>
                <Topbar
                    name={"Lessons"}
                    showOverview={showOverview}
                    setShowOverview={setShowOverview}
                    lessonsCompleted={completedLessonCount}
                    lessonLength={moduleDetails?.module_content?.length}
                    subject_name={subject_name}
                />
                <div className='p-4'>
                    <div className=''>
                        <div className='mt-1 flex items-center'>
                            <p className='leading-[12px]'><span className='text-xs opacity-50 mr-1.5 cursor-pointer' onClick={handleCourseCrumb}>{ subject_name}</span>
                            <FontAwesomeIcon icon={faChevronRight} className='opacity-50 text-xs'/>
                            <span className='text-xs opacity-50 ml-1.5 cursor-pointer' onClick={() => {
                                setShowOverview(!showOverview)
                            }}>{lessonDetails?.lesson_name}</span>
                            </p>
                        </div>
                        <p className='text-xl mt-3 opacity-50'>Lesson {lessonIndex}</p>
                        <h3 className='text-xl font-bold leading-6 mt-2' >{lessonDetails?.lesson_name}</h3>
                    </div>
                    <div className='my-3 blur-[12px] mt-6'>
                        <img src="https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-5/Rectangle_5243.png?updatedAt=1689166516241" alt="" />
                    </div>
                </div>
                <div className='m-4'>
                    <div className='relative rounded-xl border border-white/10 bg-gradient-to-br from-[#17395A] to-[#102D47] p-4'>
                        <h2 className='text-xl font-semibold'>Key Takeaways</h2>
                        <div className='blur-[3px]'>
                            <p className='leading-[19px] mt-3'>This video provides a comprehensive guide on defining your brand's target audience, a crucial step in identifying suitable influencers.</p>
                            <p className='leading-[19px] mt-3'>The insights gained will aid in finding and vetting influencers that align with your brand and resonate with your audience.</p>
                            <p className='leading-[19px] mt-3'>The knowledge will also assist in choosing between micro and macro influencers, ensuring the best fit for your brand.</p>
                        </div>
                    </div>
                </div>
                <div className='p-4'>
                    <h2 className='text-xl font-semibold mb-4'>Ask the Creator</h2>
                    <div className='flex h-16 items-center justify-between rounded-xl bg-[#17395A] p-2 blur-sm'>
                        <div className='bg-[#17395A] w-full h-[44px] relative'>
                            <p className='absolute right-2 top-2 text-[#8CC6FF]'>Send</p>
                        </div>
                    </div>
                </div>
                <div className='mx-4 mt-7 rounded-lg'>
                    <h2 className='text-xl font-semibold mb-1'>Quiz</h2>
                    <p className='italic text-sm opacity-50 mb-4'>Complete quiz to mark this lesson as complete</p>
                    <div className='rounded-xl bg-[#17395A] p-4 blur-[3px]'>
                        <p className='leading-[19px]'>What are the two types of data (demographics and ____) that you need to understand about your target market, and how do they differ?</p>
                        <div className='mt-4 h-[120px] w-full rounded-xl bg-[#102D47] p-3'>
                            <p className='opacity-50'>Answer this question in 2-3 lines</p>
                        </div>
                        <div className='bg-[#7FC241] w-[40%] text-center py-2 rounded-xl mt-3 text-[#071D2D]'>Submit</div>
                    </div>
                </div>
                {subscriptionStatus?.type === 'course_purchased' || bottomIllustrationStatus?.show_banner ? <div className='p-4 mt-4'>
                    <LearnTubeXIllustartion
                        sentinelRef={sentinelRef}
                        isAtEnd={isAtEnd}
                        setIsAtEnd={setIsAtEnd}
                        course_slug={subject_name}
                        authentication={authentication}
                    />
                </div> : <div className='w-full h-8'></div>}
            </div> : 
            <OverView
                showOverview={showOverview}
                setShowOverview={setShowOverview}
                courseName={subject_name}
                courseModule={courseModule}
                lessonId={lessonDetails?.lesson_id}
            />}
        </>
    )
}

export default LockedLessons
